import React from "react"
import HAbout from "./HAbout"
import Hero from "./hero/Hero"
import Chief from "./chief/Chief"
import Student from "./student/Student"
import Achievements from "./achievements/achievements"
import StudentVoice from "./studentVoice/StudentVoice"
import HVideo from "./hvideo/Hvideo"


const Home = () => {
  return (
    <>
      <Hero />
      <Student />
      {/* <HAbout />   */}
      <HVideo />
      <Achievements />
      <StudentVoice />
      <Chief />
      
    </>
  )
}

export default Home
